import React from 'react';
import {twMerge} from 'tailwind-merge';

import {useKeyInfoQueryContext} from '../MultiRunWorkspace/KeyInfoQueryContext';
import {AddSectionButton} from './AddSectionButton';
import {EmptySectionMessageNoMetrics} from './EmptyMessages';
import {usePanelBankConfigWithRefs} from './hooks/usePanelBankConfigWithRefs';
import {useVisibleSectionsContext} from './hooks/useVisibleSectionsContext';
import {PanelBankSections} from './PanelBankSections2';
import {PanelBankConfigState} from './types';

export const PanelBankSectionsContainer = ({
  isProjectReadOnly,
}: {
  isProjectReadOnly: boolean;
}) => {
  const panelBankConfigWithRefs = usePanelBankConfigWithRefs();
  const visibleSectionsWithRefs = useVisibleSectionsContext();
  const {
    keyInfoQuery: {historyKeyInfo},
  } = useKeyInfoQueryContext();

  if (
    panelBankConfigWithRefs.state !== PanelBankConfigState.Ready &&
    visibleSectionsWithRefs.every(s => s.activePanelRefs.length === 0) &&
    historyKeyInfo.lastStep != null &&
    historyKeyInfo.lastStep < 0
  ) {
    return (
      <div className="flex h-full w-full flex-col">
        <EmptySectionMessageNoMetrics />
        <div
          className={twMerge(
            'flex justify-end',
            'px-32 py-16',
            'border-t border-moon-300'
          )}>
          <AddSectionButton />
        </div>
      </div>
    );
  }

  return <PanelBankSections isProjectReadOnly={isProjectReadOnly} />;
};
